import type { JSONContent } from '@tiptap/core'

export type RecipientsBundle = {
  lists: string[]
  filteredViews: string[]
  phones: string[]
  contacts: string[]
}

export const questionModalFields = {
  label: 'label',
  message: 'body',
}

export const questionDelayModalFields = {
  unit: 'unit',
  amount: 'amount',
}

export const replyModalFields = {
  text: 'body',
}

export type SmsSurveyTemplate =
  | 'empty'
  | 'customer-feedback'
  | 'team-performance'
  | 'brand-awareness'
  | 'event-planning'
  | 'post-event-feedback'

export enum SmsSurveyFinalMessageFormFields {
  label = 'label',
  message = 'message',
}

export type SmsSurveyFinalMessageFormScheme = {
  [SmsSurveyFinalMessageFormFields.label]: string
  [SmsSurveyFinalMessageFormFields.message]: JSONContent
}

export const defaultFinalMessageEditorValue = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      content: [
        { type: 'text', text: 'Hi ' },
        // eslint-disable-next-line @typescript-eslint/naming-convention
        { type: 'tag', attrs: { 'data-tag': 'First name' } },
        { type: 'text', text: ' !' },
      ],
    },
    { type: 'paragraph', content: [{ type: 'text', text: 'Thank you!' }] },
  ],
}
